import React from 'react';
import { Size } from '../../../styles/theme.mjs';
import { formatDate, getFormattedRelativeTime } from '../../../utils/date.mjs';
import FlexContainer from '../../Containers/FlexContainer/FlexContainer.mjs';
import TextComponent from '../../Typography/Text/Text.mjs';
import StoryInfoAuthors from './StoryInfoAuthors.mjs';
import styled, { useTheme } from 'styled-components';

const StyledStoryInfoFlexContainer = styled(FlexContainer) `
  * {
    display: inline-block;
    margin: 0;
  }
`;
const Bullet = () => {
    const theme = useTheme();
    return (React.createElement(TextComponent, { color: theme.colors.darkGray, tag: "div", size: Size.Tiny }, "\u2022"));
};
const StoryInfo = ({ authors, date, updatedAt }) => {
    const theme = useTheme();
    return (React.createElement(StyledStoryInfoFlexContainer, { gap: "0.625rem", flexWrap: "wrap" },
        Boolean(authors.length) && (React.createElement(React.Fragment, null,
            React.createElement(StoryInfoAuthors, { authors: authors }),
            React.createElement(Bullet, null))),
        React.createElement(TextComponent, { color: theme.colors.darkGray, tag: "p", size: Size.Tiny }, formatDate(date)),
        React.createElement(Bullet, null),
        React.createElement(TextComponent, { color: theme.colors.darkGray, tag: "p", size: Size.Tiny },
            "Updated ",
            getFormattedRelativeTime(updatedAt))));
};

export { StoryInfo as default };
//# sourceMappingURL=StoryInfo.mjs.map
